module.exports = __webpack_public_path__ + "img/leslie-de-la-hoz-dental-assistant.67d6282a.png";